export default __webpack_public_path__ + "static/media/INFINITI.083d11b0.png";